module.exports = __webpack_public_path__ + "static/img/imgdoubt.645c5924.png";